import React, { createContext, useState } from 'react';

// Create a context with a default value
const VideoContext = createContext({
  vod: null,
  setVod: (vod) => {}
});

// Create a provider component
export const VideoProvider = ({ children }) => {
  const [vod, setVod] = useState(null);

  return (
    <VideoContext.Provider value={{ vod, setVod }}>
      {children}
    </VideoContext.Provider>
  );
};

export default VideoContext;